import { OnInit, Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { Router } from '@angular/router';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { DialogService } from '../../../dialog/dialog.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { DashboardService } from '../../services/dashboard.service';
import { UtilService } from 'src/modules/base/services/util.service';


@Component({
    selector: 'dashboard-banner',
    templateUrl: './dashboard-banner.component.html',
    styleUrls: ['./dashboard-banner.component.scss'],
    standalone: false
})
export class DashboardBanneromponent implements OnInit {
  @Input() data: any;
  @Output() configChanged: EventEmitter<any> = new EventEmitter();
  config: any = {};
  currentSlideIndex: number = 0;
  bannerImages: any;
  myInterval = 1500;
  localStorageKey = `dashboard_banner`;
  mobileBannerImg: any;

  constructor(private baseService: BaseService,
    private appService: AppService,
    private loader: LoaderService,
    public router: Router,
    public dialogService: DialogService,
    public storage: StorageService,
    public alerts: AlertsService,
    public utilService: UtilService,
    public dashBoardService: DashboardService
  ) {
  }

  ngOnInit() {
    console.log("this.data===>", this.data);
    this.build();
  }

   build(): void {
    const getBannerImglocalStorage = this.storage.getSessionStorageDataSync(this.localStorageKey);
    const bannerImglocalStorage: any = getBannerImglocalStorage ? getBannerImglocalStorage : null;
    this.loader.showSpinner();
    // get local stroage Data
    if (bannerImglocalStorage && bannerImglocalStorage.length > 0 && !this.utilService.isMobile()) {
      this.loader.hideSpinner();
      this.bannerImages = bannerImglocalStorage[0].documents.map((doc, i) => ({
        ...this.config.data,
        banner_link: doc.banner_link ?? '',
        bannerUrl: bannerImglocalStorage[i]?.bannerUrl ?? ''
      }));
      return;
    }
    this.dashBoardService.getWidgetData(this.data.widget_id, (data) => {
      this.loader.hideSpinner();
      this.config.data = data;
      // Refresh rate logic
      const refreshRate = this.config.data?.refresh_rate;
      this.myInterval = refreshRate ? refreshRate * 1000 : this.myInterval;
      if (data?.documents?.length > 0) {
        const documents = data.documents;

        // Mobile banner images
        const hasMobileBanner = documents.find(x => x.mobile_document_id != '');
        if (hasMobileBanner) {
          this.mobileBannerImg = documents.filter(x => x.mobile_document_id).map(doc => ({
            ...this.config.data,
            banner_link: doc.banner_link ?? '',
            bannerUrl: this.utilService.getImageUrl(doc.mobile_document_id)
          }));
        } 
        // Re-save data local Stroage
        this.bannerImages = documents.map(doc => ({
          ...this.config.data,
          banner_link: doc.banner_link ?? '',
          bannerUrl: this.utilService.getImageUrl(doc.document_id)
        }));

        // Old Data Before this Featues Implementation  #177075
        if(documents.find(x => x.mobile_document_id && x.mobile_document_id == '') && this.utilService.isMobile()){
            this.mobileBannerImg = this.bannerImages
        }
        // Save new data to session storage
        this.storage.setSessionStorageData(this.localStorageKey, this.bannerImages, () => { });
      }

      // callback for single document
      else if (data?.document_id) {
        const bannerUrl = this.utilService.getImageUrl(data.document_id);
        this.config.data.bannerUrl = bannerUrl;
         // Old Data Before this Featues Implementation  #177075
        if (this.utilService.isMobile()) {
          this.mobileBannerImg = [this.config.data];
        } else {
          this.bannerImages = [this.config.data];
        }
      }
    });
  }


  goto(link?: string) {
    if (!link) return; // handles undefined, null, '' 
    try {
      const u = new URL(link);
      const path = u.pathname.replace(/^\/+/, '') + (u.search || '');
      this.router.navigate([path]);
    } catch (e) {
      this.router.navigate([link]);
    }
  }


  onSlideChange(event: any) {
    if (event == undefined) {
      this.currentSlideIndex = 0;
    } else {
      this.currentSlideIndex = event;
    }
  }

  getBannerList() {
  return this.utilService.isMobile() ? this.mobileBannerImg : this.bannerImages;
}


}
